var render, staticRenderFns
import script from "./WxDataTable.vue?vue&type=script&lang=js"
export * from "./WxDataTable.vue?vue&type=script&lang=js"
import style0 from "./WxDataTable.vue?vue&type=style&index=0&id=6ef6adf8&prod&lang=scss"
import style1 from "./WxDataTable.vue?vue&type=style&index=1&id=6ef6adf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6adf8",
  null
  
)

export default component.exports